<template>
  <v-card class="rounded-lg">
    <v-toolbar
        class="pl-2 removeBtnPaddingRight"
        color="#DADADA"
        dense
        flat
    >
      <slot name="btn"></slot>
    </v-toolbar>
    <v-card-subtitle>
      <v-row no-gutters class="text-left text-h6 py-1">
        <v-col cols="12" md="2" class="font-weight-bold">Тип пропуска:</v-col>
        <v-col cols="12" md="10" class="text-right text-md-left">{{ item.order_type }}</v-col>
      </v-row>
      <v-divider class="grey my-1"></v-divider>
    </v-card-subtitle>
    <v-card-text>
      <v-row no-gutters class="text-left subtitle-1 pb-md-1" v-if="!!item.is_formalized">
        <v-col cols="12" md="2" class="font-weight-bold">Статус заявки:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left">
          {{ order_status(item) }}
          <v-tooltip bottom  v-if="item.automate_annul">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  small
                  class="pb-1 medium-primary"
                  v-bind="attrs"
                  v-on="on"
              >
                hdr_auto
              </v-icon>
            </template>
            <span>Аннулирована автоматически</span>
          </v-tooltip>
        </v-col>
        <v-col cols="12" md="2" class="font-weight-bold">Изменение статуса:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left">{{ correctTime(item.last_update, true) }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2" v-if="item.main_designer">
        <v-col cols="12" md="2" class="font-weight-bold">Ответственный:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.responsible">{{ item.responsible.fio }}</v-col>
        <v-col cols="12" md="2" class="font-weight-bold">Заявитель:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.main_designer">{{ item.main_designer.fio }}</v-col>
        <v-col cols="12" md="2" class="font-weight-bold">Заместитель:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.designer">{{ item.designer.fio }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2" v-else>
        <v-col cols="12" md="2" class="font-weight-bold">Ответственный:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.responsible">{{ item.responsible.fio }}</v-col>
        <v-col cols="12" md="2" class="font-weight-bold">Заявитель:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.designer">{{ item.designer.fio }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-1">
        <v-col cols="12" md="2" class="font-weight-bold">Организация:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.organization">{{ item.organization.name }}</v-col>
        <v-col cols="12" md="2" class="font-weight-bold">Территория:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.territory">{{ item.territory.name }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2">
        <v-col cols="12" md="2" class="font-weight-bold">Адрес:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.building">{{ item.building.name }}</v-col>
        <v-col cols="12" md="2" class="font-weight-bold" v-if="item.room">Помещение:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left" v-if="item.room">{{ item.room }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-1">
        <v-col cols="5" md="2" class="font-weight-bold">Дата начала:</v-col>
        <v-col cols="7" md="4" class="text-right text-md-left">{{ correctTime(item.start_date) }}</v-col>
        <v-col cols="5" md="2" class="font-weight-bold">Дата окончания:</v-col>
        <v-col cols="7" md="4" class="text-right text-md-left">{{ correctTime(item.end_date) }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2">
        <v-col cols="12" md="2" class="font-weight-bold">Цель посещения:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left">{{ item.purpose }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2"v-if="!!item.justification">
        <v-col cols="12" md="2" class="font-weight-bold">Обоснование:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left">{{ item.justification }}</v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-2"v-if="!!item.attached_file">
        <v-col cols="12" md="2" class="font-weight-bold">Файл:</v-col>
        <v-col cols="12" md="4" class="text-right text-md-left"> <a :href="item.attached_file" target="_blank">{{item.file_name}}</a> </v-col>
      </v-row>
      <v-row no-gutters class="text-left subtitle-1 py-md-1" v-if="!!item.comment">
        <v-col cols="5" md="2" class="font-weight-bold">Комментарий:</v-col>
        <v-col cols="7" md="4" class="text-right text-md-left">{{ item.comment }}</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetCar(item)"></v-divider>
      <v-row no-gutters class="text-left subtitle-1" v-if="isGetCar(item)">
        <v-col cols="12" class="text-center font-weight-bold">Автомобиль</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetCar(item)"></v-divider>
      <v-row no-gutters class="text-left subtitle-1 py-md-1" v-if="isGetCar(item)">
        <v-col cols="6" md="2">Номер:</v-col>
        <v-col cols="6" md="4" class="text-right text-md-left">{{ item.car.number }}</v-col>
        <v-col cols="6" md="2">Модель:</v-col>
        <v-col cols="6" md="4" class="text-right text-md-left">{{ item.car.model }}</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetVisitor(item)"></v-divider>
      <v-row no-gutters class="text-center subtitle-1" v-if="isGetVisitor(item)">
        <v-col cols="12" class="font-weight-bold">Список посетителей</v-col>
      </v-row>
      <v-divider class="grey my-2" v-if="isGetVisitor(item)"></v-divider>
      <v-data-table
          v-if="isGetVisitor(item)"
          :headers="headers"
          :items="item.visitors"
          :footer-props="{'items-per-page-options':[25,50,100]}"
      >
        <template v-slot:item.is_foreigner="{ item }">
          <v-icon
              :color="checkFlag(item.is_foreigner).color"
          >
            {{checkFlag(item.is_foreigner).icon}}
          </v-icon>
        </template>
        <template v-slot:item.is_in_blacklist="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                  :color="checkBlackListFlag(item.is_in_blacklist).color"
                  dark
                  v-bind="attrs"
                  v-on="on"
              >
                {{checkBlackListFlag(item.is_in_blacklist).icon}}
              </v-icon>
            </template>
            <span>{{checkBlackListFlag(item.is_in_blacklist).text}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {displayDate} from "@/helper";
import {mapActions} from "vuex";

export default {
  name: "OrderDetail",
  props: [
      "item",
      "blackListDisabled"
  ],
  data() {
    return {
      headers: [
        {text: "Фамилия", value: "last_name", sortable: false, align: "start", width: "20%"},
        {text: "Имя", value: "first_name", sortable: false, align: "start", width: "15%"},
        {text: "Отчество", value: "middle_name", sortable: false, align: "start", width: "15%"},
        {text: "Организация", value: "organization.short_name", sortable: false, align: "start", width: "30%"},
        // {text: "Иностранный гражданин", value: "is_foreigner", sortable: false, align: "center", width: "10%"},
        {text: "Ограничения", value: "is_in_blacklist", sortable: false, align: "center", width: "10%"}
      ]
    }
  },
  methods: {
    order_status (item) {
      if (item.is_formalized && item.is_agreed === null && !item.automate_annul) {
        return "Оформлена"
      } else if (item.is_withdrawn) {
        return "Отозвана"
      } else if (item.is_agreed && item.is_formalized && !item.is_annul) {
        return "Согласована"
      } else if (item.is_agreed === false && item.is_formalized) {
        return "Отклонена"
      } else if (item.is_agreed === true && item.is_annul || item.automate_annul) {
        return "Аннулирована"
      } else {
        return "Создана"
      }
    },
    correctTime (time, minute = false) {
      return displayDate(time, minute)
    },
    isGetCar(item){
      if (item.car) {
        if (item.car.length !== 0) {
          return true
        }
      } else {
        return false
      }
    },
    isGetVisitor(item){
      if (item.visitors) {
        if (item.visitors.length > 0) {
          return true
        }
      } else {
        return false
      }
    },
    checkFlag(flag) {
      if (flag) return {icon: "check_circle", color: "green"}
      else return {icon: "radio_button_unchecked", color: "grey"}
    },
    checkBlackListFlag(flag) {
      if (flag === true) return {icon: "do_not_disturb_on", color: "red", text: "Пользователь в черном списке"}
      else if (flag === false) return {icon: "radio_button_unchecked", color: "grey", text: "Ограничений нет"}
      else return {icon: "error", color: "yellow darken-2", text: "Пользователь в сером списке"}
    }
  },
  created() {
    if (this.blackListDisabled) {
      this.headers.splice(4, 1)
    }
  }
}
</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
